export default __webpack_public_path__ + "static/media/home-magazine-img-04.b386f2d7.jpg";